// extracted by mini-css-extract-plugin
export var productImage = "_jw-1";
export var viewLink = "_jw-2";
export var wishlistItem = "_jw-0";